/** Fallback histórico da região online (só se o seller não trouxer regionId). */
export const WEB_REGION_ID = '9b4e0e64-3157-474d-b385-33cc084efcdf'

/**
 * Região de apostas: prioriza seller/tenant; ONLINE só como último fallback.
 */
export function resolveRegionId(...candidates) {
  for (const id of candidates) {
    const value = String(id || '').trim()
    if (value && value !== 'null' && value !== 'undefined') return value
  }

  try {
    const fromLs = String(localStorage.getItem('regionId') || '').trim()
    if (fromLs) return fromLs

    const client = JSON.parse(localStorage.getItem('client') || 'null')
    const fromClient = String(client?.regionId || client?.RegionId || '').trim()
    if (fromClient) return fromClient

    const seller = JSON.parse(localStorage.getItem('seller') || 'null')
    const fromSeller = String(seller?.regionId || seller?.RegionId || '').trim()
    if (fromSeller) return fromSeller
  } catch {
    // ignore
  }

  return WEB_REGION_ID
}
